<ng-template #smalBlockUi>
    <p-button
        [pTooltip]="
            !checkIfCanSave()
                ? ('address.save-address-first' | translate)
                : ('address.missing-data-for-save' | translate)
        "
        [loading]="isSaving"
        icon="fa fa-save"
        [label]="'address.save-address-first' | translate"
        [disabled]="checkIfCanSave()"
        (onClick)="saveToUnlockEditMode()"
    ></p-button>
</ng-template>

<blockable-div #smalBlock [blocked]="!model.id" [blockUi]="smalBlockUi">
    <!-- make sure addressId is in there first render -->
    @if (model.id) {
        <app-shipping-method-address-link-list-widget
            [autoFocusSearch]="false"
            [fillHeightList]="false"
            [address]="this.model"
            [addInDialog]="true"
            [addInDetail]="false"
            [inlineEditMode]="false"
        />
    }
</blockable-div>
